// Tiny dependency-free CSV builder + downloader.
// Excel opens .csv perfectly; column order is preserved.

function escapeCell(v) {
  if (v == null) return "";
  const s = typeof v === "string" ? v : String(v);
  const needsQuote = /[",\n\r]/.test(s);
  const escaped = s.replace(/"/g, '""');
  return needsQuote ? `"${escaped}"` : escaped;
}

/**
 * @param {Array<Object>} rows - array of plain objects
 * @param {Array<{key: string, label: string, format?: (v:any,row:any)=>string}>} columns
 */
export function rowsToCsv(rows, columns) {
  const header = columns.map((c) => escapeCell(c.label)).join(",");
  const body = rows.map((row) =>
    columns
      .map((c) => {
        const raw = row[c.key];
        const val = c.format ? c.format(raw, row) : raw;
        return escapeCell(val);
      })
      .join(",")
  );
  return [header, ...body].join("\r\n");
}

export function downloadCsv(filename, csv) {
  // Prepend BOM so Excel opens UTF-8 correctly (accents, symbols)
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export function exportRows(filename, rows, columns) {
  downloadCsv(filename, rowsToCsv(rows, columns));
}

export function todayStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
